var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-info_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.997 13.792a.531.531 0 00.387-.156.518.518 0 00.159-.386V9.542A.527.527 0 0010.006 9a.532.532 0 00-.388.156.52.52 0 00-.158.386v3.708c0 .154.051.282.154.386.103.104.23.156.383.156zm0-6.051a.581.581 0 00.594-.586.581.581 0 00-.585-.594.581.581 0 00-.594.585.581.581 0 00.585.595zm.011 9.842a7.407 7.407 0 01-2.947-.592 7.644 7.644 0 01-2.42-1.629 7.647 7.647 0 01-1.63-2.419 7.408 7.408 0 01-.593-2.951c0-1.047.197-2.028.592-2.943a7.646 7.646 0 014.048-4.04 7.408 7.408 0 012.951-.592c1.047 0 2.028.197 2.943.592a7.676 7.676 0 014.04 4.043 7.36 7.36 0 01.593 2.941 7.409 7.409 0 01-.592 2.947 7.646 7.646 0 01-4.043 4.051 7.36 7.36 0 01-2.942.592zm-.007-1.083c1.806 0 3.34-.632 4.604-1.896 1.264-1.264 1.896-2.798 1.896-4.604 0-1.805-.632-3.34-1.896-4.604C13.342 4.132 11.807 3.5 10.002 3.5c-1.805 0-3.34.632-4.604 1.896C4.133 6.66 3.501 8.195 3.501 10c0 1.806.632 3.34 1.896 4.604 1.264 1.264 2.799 1.896 4.604 1.896z",
    fill: "#1C1B1F"
  }))));
}
export default SvgIcnInfo;